import React from 'react';
import { connect } from 'react-redux';
import styles from '../Filters.module.scss';
import { RootState } from 'MyTypes';
import { areFiltersAppliedSelector } from '../../../filterSelectors';
import { bindActionCreators, Dispatch } from 'redux';
import { clearAllFilters } from '../../../filterActions';

const mapStateToProps = (state: RootState) => ({
    isFiltered: areFiltersAppliedSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch) =>
    bindActionCreators(
        {
            handleClearAllFilters: clearAllFilters,
        },
        dispatch,
    );

type Props = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps> & {
        closeAllFilters: () => void;
    };

const ClearAll: React.FC<Props> = ({
    isFiltered,
    handleClearAllFilters,
    closeAllFilters,
}) => {
    if (!isFiltered) return null;
    return (
        <div className={styles.filterClearAllControls}>
            <button
                className={styles.filterClearButton}
                onClick={() => {
                    handleClearAllFilters();
                    closeAllFilters();
                }}
            >
                Clear all filters
            </button>
        </div>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ClearAll);
